import { Btn, Eyebrow, linkStyle, listReset } from '../components/primitives';
import { useOpenPublisherModal } from '../components/publisher-modal';
import questBoundLogo from '../assets/qb-logo.png';

export const FinalCTA = () => {
  const openPublisherModal = useOpenPublisherModal();
  return (
  <section
    className="qb-final-cta"
    style={{
      padding: '140px 40px 130px',
      textAlign: 'center',
      position: 'relative',
      borderBottom: '1px solid var(--qb-border-soft)',
      overflow: 'hidden',
    }}>
    <div
      style={{
        position: 'absolute',
        inset: 0,
        background:
          'radial-gradient(ellipse at 50% 50%, var(--qb-orange-900) 0%, transparent 60%)',
        opacity: 0.55,
        pointerEvents: 'none',
      }}
    />
    <div style={{ position: 'relative', zIndex: 2, maxWidth: 1100, margin: '0 auto' }}>
      <Eyebrow>READY?</Eyebrow>
      <h2
        className="qb-cta-h2"
        style={{
          fontFamily: 'var(--qb-font-display)',
          textTransform: 'uppercase',
          fontSize: 96,
          lineHeight: 0.92,
          letterSpacing: '-0.02em',
          margin: '18px auto 28px',
          maxWidth: 1000,
          textWrap: 'balance',
        }}>
        Bring your <span style={{ color: 'var(--qb-orange-500)' }}>game</span> to the world.
      </h2>
      <p
        className="qb-cta-lead"
        style={{
          fontFamily: 'var(--qb-font-body)',
          fontStyle: 'italic',
          fontSize: 19,
          color: 'var(--qb-fg-muted)',
          margin: '0 auto 36px',
          maxWidth: 600,
        }}>
        Free to build forever. Pay only when you start selling.
      </p>
      <div style={{ display: 'flex', justifyContent: 'center', gap: 14, flexWrap: 'wrap' }}>
        <Btn size="lg" href="https://app.questbound.com">Start Building — Free</Btn>
        <Btn kind="secondary" size="lg" href="#" onClick={openPublisherModal}>
          Become a Publisher →
        </Btn>
      </div>
    </div>
  </section>
  );
};

export const Footer = () => {
  const cols: [string, [string, string | undefined][]][] = [
    [
      'PLATFORM',
      [
        ['Engine', 'https://app.questbound.com'],
        ['Pricing', '#pricing'],
      ],
    ],
    [
      'RESOURCES',
      [
        ['Documentation', 'https://docs.questbound.com'],
        ['QBScript reference', 'https://docs.questbound.com/docs/scripts/qbscript'],
      ],
    ],
    [
      'COMMUNITY',
      [
        ['GitHub', 'https://github.com/curtmorgan3/quest-bound'],
        ['Discord', 'https://discord.gg/7QGV4muT39'],
      ],
    ],
    [
      'COMPANY',
      [
        ['Contact', 'mailto:curt@questbound.com'],
        ['Terms', 'https://docs.questbound.com/docs/terms'],
        ['Privacy', 'https://docs.questbound.com/docs/privacy'],
        ['DMCA', 'https://docs.questbound.com/docs/dmca'],
      ],
    ],
  ];


  return (
    <footer className="qb-section" style={{ padding: '72px 40px 36px', background: 'var(--qb-ink-900)' }}>
      <div
        className="qb-footer-grid"
        style={{
          maxWidth: 1280,
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: '1.6fr 1fr 1fr 1fr 1fr',
          gap: 48,
        }}>
        <div className="qb-footer-brand">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              marginBottom: 16,
            }}>
            <img src={questBoundLogo} style={{ height: 30 }} alt="" />
            <span
              style={{
                fontFamily: 'var(--qb-font-display)',
                fontSize: 15,
                letterSpacing: '0.06em',
              }}>
              QUEST BOUND
            </span>
          </div>
          <p
            style={{
              fontFamily: 'var(--qb-font-body)',
              fontSize: 14,
              lineHeight: 1.6,
              color: 'var(--qb-fg-muted)',
              maxWidth: 320,
              margin: '0 0 18px',
            }}>
            The end-to-end platform for digital tabletop role-playing games. Build a Ruleset, sell
            it, run the table.
          </p>
        </div>
        {cols.map(([h, ls]) => (
          <div key={h}>
            <Eyebrow style={{ marginBottom: 14, color: 'var(--qb-fg-subtle)' }}>{h}</Eyebrow>
            <ul
              style={{
                ...listReset,
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
                fontFamily: 'var(--qb-font-body)',
                fontSize: 14,
                color: 'var(--qb-fg-muted)',
              }}>
              {ls.map(([label, href]) => (
                <li key={label}>
                  <a
                    className="qb-nav-link"
                    style={linkStyle}
                    href={href}
                    target={href && /^https?:/.test(href) ? '_blank' : undefined}
                    rel={href && /^https?:/.test(href) ? 'noreferrer' : undefined}>
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div
        className="qb-footer-bottom"
        style={{
          maxWidth: 1280,
          margin: '56px auto 0',
          paddingTop: 24,
          borderTop: '1px solid var(--qb-border-soft)',
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 16,
          color: 'var(--qb-fg-subtle)',
          fontFamily: 'var(--qb-font-display)',
          textTransform: 'uppercase',
          fontSize: 10,
          letterSpacing: '0.16em',
        }}>
        <span>© 2026 Quest Bound</span>
        <span>Augments your table — never replaces it</span>
      </div>
    </footer>
  );
};
